// 관세사(customs_broker) 전용 대시보드 (Wave 4.x, 2026-05-28)
//   재고/차량 현황 없음 — 면장 처리 큐 중심. 기존 엔드포인트 재사용:
//     GET /clearance-broker/me      → { agency, counts:{대기,완료,total} }
//     GET /clearance-broker/queue   → { items:[...] } (마스킹된 표시용)
//   CTA → /main/customs-broker (면장 처리 포털).
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

var NAVY = '#1B3A5C';

function DashboardCustomsBroker({ user }) {
  var navigate = useNavigate();
  var meState = useState(null); var me = meState[0]; var setMe = meState[1];
  var waitingState = useState([]); var waiting = waitingState[0]; var setWaiting = waitingState[1];
  var loadingState = useState(true); var loading = loadingState[0]; var setLoading = loadingState[1];

  function loadData() {
    authFetch(API + '/clearance-broker/me')
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d && d.success) setMe(d); })
      .catch(function() {});
    authFetch(API + '/clearance-broker/queue?status=' + encodeURIComponent('대기'))
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d && d.success) setWaiting(d.items || []); setLoading(false); })
      .catch(function() { setLoading(false); });
  }

  useEffect(function() { loadData(); }, []);

  // 실시간 의뢰 도착 — 소켓 clearance:new-request → 대시보드 재조회 (재로그인 불필요)
  useEffect(function() {
    var sock = getSocket();
    if (!sock) return;
    function onNewRequest() { loadData(); }
    sock.on('clearance:new-request', onNewRequest);
    return function() { try { sock.off('clearance:new-request', onNewRequest); } catch (e) {} };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var counts = (me && me.counts) || { '대기': 0, '완료': 0, total: 0 };
  var agencyName = (me && me.agency && me.agency.name) || (user && user.name) || '관세사';
  var goPortal = function() { navigate('/main/customs-broker'); };

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1100, margin: '0 auto' }}>
      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>{'📦 ' + agencyName}</div>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>{'수출면장 처리 현황'}</div>
        </div>
        <button onClick={goPortal}
          style={{ padding: '10px 20px', background: NAVY, color: '#fff', border: 'none', borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          {'면장 처리하러 가기 →'}
        </button>
      </div>

      {/* KPI 카드 — 재고 없음, 면장 큐 중심 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
        <KpiCard icon="⏳" label="대기 면장" value={counts['대기'] || 0} unit="건" color="#ea580c" highlight={(counts['대기'] || 0) > 0} />
        <KpiCard icon="✅" label="처리 완료" value={counts['완료'] || 0} unit="건" color="#16a34a" />
        <KpiCard icon="📋" label="전체 의뢰" value={counts.total || 0} unit="건" color={NAVY} />
      </div>

      {/* 대기 면장 목록 */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: NAVY }}>{'대기 중인 면장'}</h3>
          <span style={{ fontSize: 12, color: '#94a3b8' }}>{'최신순'}</span>
        </div>
        <div style={{ maxHeight: 'calc(100vh - 380px)', overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f8fafc', color: '#475569', position: 'sticky', top: 0 }}>
                <th style={thS}>{'의뢰 업체'}</th>
                <th style={thS}>{'차종'}</th>
                <th style={thS}>{'차량번호'}</th>
                <th style={thS}>{'신청일'}</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={4} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'불러오는 중...'}</td></tr>}
              {!loading && waiting.length === 0 && (
                <tr><td colSpan={4} style={{ padding: 36, textAlign: 'center', color: '#94a3b8' }}>{'대기 중인 면장이 없습니다'}</td></tr>
              )}
              {!loading && waiting.map(function(it) {
                return (
                  <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9', cursor: 'pointer' }}
                    onClick={goPortal}
                    onMouseEnter={function(e) { e.currentTarget.style.background = '#f8fafc'; }}
                    onMouseLeave={function(e) { e.currentTarget.style.background = '#fff'; }}>
                    <td style={tdS}>{it.companyName}</td>
                    <td style={tdS}>{it.carType}</td>
                    <td style={Object.assign({ fontWeight: 600 }, tdS)}>{it.carNo}</td>
                    <td style={Object.assign({ color: '#64748b' }, tdS)}>{it.requestDate}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function KpiCard({ icon, label, value, unit, color, highlight }) {
  return (
    <div style={{
      background: highlight ? '#fff7ed' : '#fff',
      borderRadius: 12,
      border: '1px solid ' + (highlight ? '#fed7aa' : '#e5e7eb'),
      padding: '18px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 14
    }}>
      <div style={{ fontSize: 26, width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', background: color + '14', borderRadius: 12 }}>{icon}</div>
      <div>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 2 }}>{label}</div>
        <div style={{ fontSize: 26, fontWeight: 800, color: color, lineHeight: 1 }}>
          {Number(value).toLocaleString()}<span style={{ fontSize: 14, fontWeight: 500, marginLeft: 2, color: '#94a3b8' }}>{unit}</span>
        </div>
      </div>
    </div>
  );
}

var thS = { padding: '10px 14px', textAlign: 'left', fontWeight: 700, fontSize: 12, borderBottom: '1px solid #e5e7eb' };
var tdS = { padding: '10px 14px', color: '#334155' };

export default DashboardCustomsBroker;
